import { gql } from "@apollo/client";

// Execute Dynamic Query (Aurora SQL)
export const EXECUTE_AURORA_SQL_QUERY = gql`
  query ExecuteDynamicQuery($query: DynamicQueryInput!) {
    executeDynamicQuery(query: $query) {
      success
      data
      totalCount
      hasMore
      error
      queryInfo {
        sqlQuery
        executionTime
        tablesQueried
      }
    }
  }
`;

// Get Query Builder Schema
export const GET_QUERY_BUILDER_SCHEMA_QUERY = gql`
  query GetQueryBuilderSchema {
    getQueryBuilderSchema {
      tables {
        name
        displayName
        description
        fields {
          name
          displayName
          type
          description
          sampleValues
        }
      }
    }
  }
`;

// Get Agent Results (Alternative query)
export const GET_AGENT_RESULTS_QUERY = gql`
  query GetAgentResults($query: AgentResultsQueryInput!) {
    getAgentResults(query: $query) {
      success
      data
      totalCount
      hasMore
      error
    }
  }
`;
